const Hogan = require("hogan.js");
const _extend = Object.assign;

const wrap_with_render = (callback, template) => () =>
    function (text) {
        const data = template.c.compile(text || "", template.options).render(this);
        return callback.bind(this)(data);
    };

/**
 * Transforms a distance in meters into an human readable string.
 * @param {Number} meterDistance
 * @returns {string}
 * @private
 */
function human_distance(meterDistance) {
    let distance = "";
    if (meterDistance) {
        distance = Number.parseFloat(meterDistance);
        if (distance >= 1000) {
            distance = distance / 1000;
            distance = `${distance.toFixed(1)}km`;
        } else {
            distance = `${distance.toFixed(0)}m`;
        }
        return distance;
    }
}

const _lambdaLibrary = {
    human_distance: human_distance,
};

/**
 * Adds a lambda in the lambda library
 * @param {String} name the name used for the tag
 * @param {Function} lambda the function that do something with the input from template
 * @example
 * // registers a template lambda to be used like this: {{%hello}}{{user.name}}{{/hello}}
 * woosmap.templates.registerLambda('hello', function(human) {
 *    return "Hello " + human + "."
 * });
 */
const registerLambda = (name, lambda) => {
    _lambdaLibrary[name] = lambda;
};

/**
 * Constructs a TemplateRendererInstance
 * @param {string} template the hogan.js template string
 * @constructor
 * @memberOf woosmap
 */
const TemplateRenderer = function (template) {
    this._template = template;
    this._compiled_template = Hogan.compile(this._template);
    this._lambdas = {};
    this._registerLambdaLibrary();
};

/**
 * Registers all the lambdas in lambdaLibrary
 * @see registerLambda
 * @private
 */
TemplateRenderer.prototype._registerLambdaLibrary = function () {
    for (const lambdaName in _lambdaLibrary) {
        if (_lambdaLibrary.hasOwnProperty(lambdaName)) {
            this.registerLambda(lambdaName, _lambdaLibrary[lambdaName]);
        }
    }
};

/**
 * Renders the compiled template with the context
 * @param {object} [properties] the template context.
 * @returns {*}
 * @example
 * var templateRenderer = new woosmap.TemplateRenderer('<h1>{{user_text}}</h1>')
 * templateRenderer.render({"user_text": "Hello world!"});
 * // this should return '<h1>Hello world!</h1>'
 */
TemplateRenderer.prototype.render = function (properties) {
    properties = properties || {};
    properties = _extend({}, properties, this._lambdas);
    return this._compiled_template.render(properties);
};

/**
 * Registers a template Lambda
 * @param {String} name
 * @param {Function} lambda
 */
TemplateRenderer.prototype.registerLambda = function (name, lambda) {
    this._lambdas[name] = wrap_with_render(lambda, this._compiled_template);
};

exports.TemplateRenderer = TemplateRenderer;
exports.registerLambda = registerLambda;
